import { StatusFilterValue } from './state/tab-filter-state';

export enum TaskTab {
    UNASSIGNED = 'unassigned',
    ASSIGNED_TO_ME = 'assigned_to_me',
    CREATED_REQUESTS = 'created_requests',
    MDLA_REQUESTS = 'mdla_requests',
    MY_RESPONSE_NEEDED = 'my_response_needed'
}

export enum SubTaskTab {
    UNASSIGNED = 'subtasks_unassigned',
    ASSIGNED_TO_ME = 'subtasks_assigned_to_me',
    CREATED = 'subtasks_created',
    ALL = 'subtasks_all'
}

export type PersistedFilterState = {
    status?: StatusFilterValue[];
};
